var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuChatColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_497_4875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H15.2727V13.3636H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_497_4875)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6368 4.49123H4.46414C4.12147 4.49123 3.84335 4.22147 3.84335 3.88819C3.84335 3.55532 4.12147 3.28516 4.46414 3.28516H11.6368C11.9795 3.28516 12.2576 3.55532 12.2576 3.88819C12.2576 4.22147 11.9795 4.49123 11.6368 4.49123M11.6368 7.30546H4.46414C4.12147 7.30546 3.84335 7.0357 3.84335 6.70242C3.84335 6.36955 4.12147 6.09939 4.46414 6.09939H11.6368C11.9795 6.09939 12.2576 6.36955 12.2576 6.70242C12.2576 7.0357 11.9795 7.30546 11.6368 7.30546M2.39626 0C1.0748 0 0 1.04406 0 2.32772V12.7603C0 13.2544 0.575226 13.5329 0.981265 13.2511L4.39438 10.8856C4.68077 10.6874 5.01766 10.5825 5.36944 10.5825H12.8765C14.1979 10.5825 15.2727 9.53844 15.2727 8.25478V0.603037C15.2727 0.270161 14.9946 0 14.6519 0H2.39626Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6.63913V17.9158C21 18.4463 20.4379 18.7531 20.0363 18.4464L16.6841 15.8898C16.4028 15.6756 16.0719 15.5622 15.7264 15.5622H8.35347C7.05561 15.5622 6 14.4331 6 13.0456V11.8096H12.8352C14.8054 11.8096 16.4081 10.0961 16.4081 7.98977V4.12253H18.6465C19.9444 4.12253 21 5.25154 21 6.63913L15.1762 0.568359",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuChatColor);
export default __webpack_public_path__ + "static/media/menu-chat-color.81e41e830826806e9236fecd44cb4487.svg";
export { ForwardRef as ReactComponent };